import principalImg from "../assets/image/principal.jpeg";

function OurFaculties() {

const teachers = [
  // { name: "G Jagmeet", role: "Principal", qual: "M.Phil, B.Ed" },
  { name: "Deepika S", role: "Coordinator", qual: "M.Sc, B.Ed" },
  { name: "Annanya D Prakash", role: "Coordinator", qual: "B.Sc" },

  { name: "Nandini B", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Chandramma M", role: "Physical Education", qual: "B.A, B.P.Ed, NIS" },
  { name: "Priya K P", role: "Teacher", qual: "B.Ed" },
  { name: "Minita Kenedy", role: "English Teacher", qual: "M.A" },
  { name: "Shubha Madhusudhan", role: "Social Science Teacher", qual: "B.A, M.A" },
  { name: "Uma H S", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Sowmya S B", role: "Teacher", qual: "M.Sc, B.Ed" },
  { name: "Shridevi", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Sowmya C", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Suvarna", role: "Art & Craft", qual: "B.A" },
  { name: "Parveen Taj", role: "Teacher", qual: "SSLC, NST" },
  { name: "Ashwini Dharigoudar", role: "Computer Science Teacher", qual: "Diploma in Computer Science" },
  { name: "Lakshmi S", role: "Teacher", qual: "D.Ed, B.Sc (CBZ)" },
  { name: "Seetha Bai K S", role: "Teacher", qual: "M.Sc, B.Ed" },
  { name: "Rani Devi Yadav", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Swetha N", role: "Teacher", qual: "M.Sc, B.Ed" },
  { name: "Shanthala H R", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Malini A M", role: "Teacher", qual: "M.Sc (CS)" },
  { name: "Ramya J V", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Hemanth Kumar B", role: "Swimming coach", qual: "B.E" },
  { name: "Latha M", role: "Teacher", qual: "M.Com, PGDHRM" },
  { name: "Sahana R C", role: "Teacher", qual: "B.Sc, B.Ed" },
  { name: "Anitha K R", role: "Teacher", qual: "M.Sc, B.Ed" },
  { name: "Aparna K J", role: "Teacher", qual: "B.B.A, B.Ed" },
  { name: "Sunitha D D", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Srilakshmi C N", role: "Teacher", qual: "B.A, Montessori Training" },
  { name: "Sowmya S", role: "Teacher", qual: "B.Sc, B.Ed" },
  { name: "Preetishree", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Ashwini", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Anjali Manral", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Roopa L G", role: "Teacher", qual: "Diploma in IS, BCA" },
  { name: "Apoorva K B", role: "Teacher", qual: "B.Com, M.Com, Diploma in Montessori" },
  { name: "Nandini Naveen", role: "Teacher", qual: "B.Com, PGDHRM" },
  { name: "Sowmya Gurkar M S", role: "Teacher", qual: "B.Ed, M.A Clinical Psychology, Montessori Training" },
  { name: "Arathy K", role: "Teacher", qual: "M.Com, B.Ed" },
  { name: "Shamira Sulthana", role: "Teacher", qual: "M.A, B.Ed" },
  { name: "Afreen Azmi K", role: "Teacher", qual: "B.Sc, M.Sc, B.Ed" },
  { name: "Reshma Sampath Kumar", role: "Teacher", qual: "B.Com" },
  { name: "Sahana K S", role: "Teacher", qual: "B.A, NST" },
  { name: "Soumya G", role: "Teacher", qual: "M.A, B.Com" },
  { name: "Thejaswini D", role: "Teacher", qual: "M.Sc" },
  { name: "Shwetha G C", role: "Swimming coach", qual: "B.A, B.P.Ed" },
  { name: "Apoorva V Sarathy", role: "Teacher", qual: "BBM" },
  { name: "Gunasheela C Y", role: "Art & Craft", qual: "ADFT" },
  { name: "Sudha B V", role: "Teacher", qual: "B.Com, B.Ed" },
  { name: "Mamtha Kumar", role: "Teacher", qual: "B.Sc, B.Ed" },
  { name: "Kavitha Bhutada", role: "Teacher", qual: "MBA, B.Ed" },
  { name: "Asma Farheen", role: "Teacher", qual: "M.Sc, B.Ed" },
  { name: "Puspalatha A R", role: "Teacher", qual: "B.Sc, LL.B" },
  { name: "Shaista Banu", role: "Teacher", qual: "M.Sc, B.Ed" },
  { name: "Mithu B", role: "Teacher", qual: "M.A, B.Sc" },
  { name: "Kavya R", role: "Teacher", qual: "B.Ed" },
  { name: "Reshma B", role: "Teacher", qual: "B.Ed" },
  { name: "Divyashree S", role: "Teacher", qual: "B.Ed" },
  { name: "Kusuma M K", role: "Teacher", qual: "B.Ed" },
  { name: "Nisha", role: "Teacher", qual: "B.Ed" },
  { name: "Raghavendra N", role: "physical Education", qual: "B.PED,M.PED" },
  { name: "Syeda Sameena Zehara", role: "Teacher", qual: "B.Com, Diploma in Montessori, B.Ed" },

  { name: "M P Shashikala", role: "Admin Staff", qual: "Diploma in Fashion Designing" },
  { name: "S Ramya", role: "Accountant", qual: "M.Com, PGDHRM, Diploma in CP" },
  { name: "A S Jeevitha Iyer", role: "Admin Staff", qual: "B.Com" },
  { name: "Shwetha M R", role: "Admin Staff", qual: "B.Com" }
];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">

        <h1 className="text-4xl font-bold text-blue-900 mb-10">
          Our Faculties
        </h1>

        {/* Management */}
        <div className="mb-10">
          <h2 className="text-2xl font-bold text-yellow-500 mb-4">
            Management
          </h2>

          <ul className="space-y-2 text-gray-700">
            <li>Mr. V K Parthasarathy – Chief Mentor</li>
            <li>Mr. G.C. Chandrashekhar – Chairman</li>
            <li>Dr. Sudha Chandrashekhar – Secretary</li>
            <li>Mrs. Indira Kulai – CEO</li>
          </ul>
        </div>

        {/* Principal Message */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-yellow-500 mb-6">
            Principal's Message
          </h2>

          <div className="bg-yellow-50 border border-yellow-200 rounded-3xl shadow-lg p-8">
            <div className="flex flex-col md:flex-row gap-10">

              {/* Left Side - Photo & Details */}
              <div className="flex-shrink-0 text-center">
                <div className="bg-yellow-100 p-4 rounded-2xl inline-block shadow-md">
                  <img
                    src={principalImg}
                    alt="Mrs. G Jagmeet"
                    className="w-64 rounded-xl border-4 border-yellow-400"
                  />
                </div>

                <h3 className="text-2xl font-bold text-blue-900 mt-4">
                  Jagmeet Kaur
                </h3>

                <p className="text-yellow-600 font-semibold text-lg">
                  Principal
                </p>
              </div>

              {/* Right Side - Message */}
              <div className="flex-1">
                <p className="text-gray-700 leading-8 mb-5 text-justify">
                  Welcome to Capitol Public School. We believe that education is the
                  foundation of a successful and meaningful life. Our mission is to
                  provide a nurturing environment where students develop academically,
                  socially, emotionally, and morally while embracing values of
                  integrity, responsibility, and respect.
                </p>

                <p className="text-gray-700 leading-8 mb-5 text-justify">
                  With the support of our dedicated teachers, caring staff, and
                  involved parents, we strive to inspire every child to discover
                  their talents, think creatively, and become confident lifelong
                  learners prepared for future challenges. We encourage our students
                  to dream big, work hard, and become compassionate leaders who
                  contribute positively to society.
                </p>

                <p className="text-gray-700 leading-8 mb-5 text-justify">
                  At Capitol Public School, we are committed to fostering excellence,
                  innovation, and character. We continuously create opportunities
                  for students to excel in academics, sports, arts, and co-curricular
                  activities, ensuring their holistic development.
                </p>

                <p className="text-gray-700 leading-8 text-justify">
                  Together, let us continue to build a vibrant learning community
                  where every child feels valued, empowered, and inspired to achieve
                  their highest potential.
                </p>

                {/* <div className="mt-8">
                  <p className="text-blue-900 font-bold text-xl">
                    Mrs. G Jagmeet
                  </p>
                  <p className="text-yellow-600 font-semibold">
                    Principal
                  </p>
                </div> */}
              </div>

            </div>
          </div>
        </div>

         {/* Primary & Secondary */}
        <h2 className="text-2xl font-bold text-yellow-500 mb-6">
          Primary & Secondary
        </h2>

        <div className="overflow-hidden rounded-2xl shadow border">
          <table className="w-full text-left border-collapse">

            <thead className="bg-blue-900 text-white">
              <tr>
                <th className="px-6 py-4">Name</th>
                <th className="px-6 py-4">Designation</th>
                <th className="px-6 py-4">Qualification</th>
              </tr>
            </thead>

            <tbody>
              {teachers.map((t, index) => (
                <tr
                  key={index}
                  className={`border-t ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-yellow-50 transition`}
                >
                  <td className="px-6 py-4 font-medium text-gray-800">
                    {t.name}
                  </td>

                  <td className="px-6 py-4 text-gray-700">
                    {t.role || "-"}
                  </td>

                  <td className="px-6 py-4 text-gray-700">
                    {t.qual || "-"}
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>




      </div>
    </section>
  );
}

export default OurFaculties;